// Polyfill Events for IE11 lol

(function() {
  if (typeof window.Event === "function") return false;

  function Event(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: null };
    var evt = document.createEvent("Event");
    evt.initEvent(
      event,
      params.bubbles,
      params.cancelable,
      params.detail
    );
    return evt;
  }

  window.Event = Event;
})();
